export default "__VITE_ASSET__JdzrEVpy__"